import { useEffect, useState, useRef } from "react";
import '../../assets/css/vaultaccess.css';
import '../../assets/css/vaultempty.css';
import VaultAccessSection from "./VaultAccessSection";
import { styleSearch } from "../../api/jewelleryService";
import { FilterProvider, useFilters } from "../../Context/FilterContext";

export default function vaultaccess() {
    document.title = "Vault Access";
    return (
        <FilterProvider>
            <VaultAccessMain />
        </FilterProvider>
    );
}

function VaultAccessMain() {

    const { selectedFilters, selectedCategory, setContextData, sort, products, hasMore, refreshKey } = useFilters();
    const [totalRecordCounts, setTotalRecordsCount] = useState(0);
    const [currentRecordCounts, setCurrentRecordsCount] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const isInitialRender = useRef(true);
    const [page, setPage] = useState(1);
    const productsRef = useRef([]);
    const prevFilterKeyRef = useRef(null);
    const pageSize = 50;
    const didFetchRef = useRef(false);


    const filterKey = JSON.stringify({
        selectedFilters,
        selectedCategory,
        sort,
        refreshKey,
    });

    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            prevFilterKeyRef.current = filterKey;
            fetchProductData(1, true);
            return;
        }

        if (prevFilterKeyRef.current === filterKey) {
            return;
        }

        prevFilterKeyRef.current = filterKey;
        productsRef.current = [];
        setPage(1);
        fetchProductData(1, true);

    }, [filterKey]);

    const fetchProductData = async (pageNo, reset = false) => {
        setIsFetching(true);
        try {
            const payload = {
                Party_ID: selectedFilters.Party_ID || "",
                Category: selectedCategory || "",
                SubCategory: "",
                Metal: (selectedFilters["Metal Tone"] || []).map(x => x.value).join("~"),
                GoldQuality: (selectedFilters["Gold Quality"] || []).map(x => x.value).join("~"),
                DiamondShape: (selectedFilters["Diamond Shape"] || []).map(x => x.value).join("~"),
                DiamondQuality: (selectedFilters["Diamond Quality"] || []).map(x => x.value).join("~"),
                Collection: (selectedFilters["Collection"] || []).map(x => x.value).join("~"),
                ItemSize: (selectedFilters["Item Size"] || []).map(x => x.value).join("~"),
                StyleNo: selectedFilters["Ring Style"] || "",
                FromPrice: String(selectedFilters["Price"]?.from ?? "0"),
                ToPrice: String(selectedFilters["Price"]?.to ?? "10000000"),
                FromCarat: String(selectedFilters["Carat"]?.from ?? "0"),
                ToCarat: String(selectedFilters["Carat"]?.to ?? "100"),
                FromGoldWeight: String(selectedFilters["Gold Weight"]?.from ?? "0"),
                ToGoldWeight: String(selectedFilters["Gold Weight"]?.to ?? "250"),
                PageNo: String(pageNo),
                PageSize: String(pageSize),
                Style_ID: "",
                SortBy: String(sort) || "",
            };
            //console.log("payload", payload)
            const response = await styleSearch(payload);

            const message = response?.Message?.[0];

            if (String(message?.RETURNCODE) !== "1") {
                setErrorMessage(message?.RETURNMESSAGE || "Products not found");

                productsRef.current = [];
                setTotalRecordsCount(0);
                setCurrentRecordsCount(0);
                setIsFetching(false);
                return;
            }

            const list = response?.Products || [];
            const currentRecords = list.length;
            const totalPages = response?.Pagination?.[0]?.Total_Page || 1;
            const totalRecords = response?.Pagination?.[0]?.Total_Record || 0;
            setTotalRecordsCount(totalRecords);
            setCurrentRecordsCount(prev =>
                reset ? list.length : prev + list.length
            );
            const finalProducts = reset ? list
                : [...productsRef.current, ...list];
            productsRef.current = finalProducts;
            setContextData({
                products: finalProducts,
                hasMore: pageNo < totalPages
            });
        } catch (error) {
            console.log("error", error)
        } finally {
            setIsFetching(false);
        }
    };

    const loadMore = () => {
        if (isFetching) return;

        setPage(prev => {
            const next = prev + 1;
            fetchProductData(next);
            return next;
        });
    };

    return (
        <>
            <div className="main-container-vaultaccess">
                <VaultAccessSection
                    loadMore={loadMore}
                    totalProductCount={totalRecordCounts}
                    currentRecordCounts={currentRecordCounts}
                    isFetching={isFetching}
                    errorMessage={errorMessage}
                />
            </div>
        </>
    );
}
